import { render, staticRenderFns } from "./newincreased.vue?vue&type=template&id=0bc16128&scoped=true&"
import script from "./newincreased.vue?vue&type=script&lang=js&"
export * from "./newincreased.vue?vue&type=script&lang=js&"
import style0 from "./newincreased.vue?vue&type=style&index=0&id=0bc16128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc16128",
  null
  
)

export default component.exports